
import { HttpClient } from '@angular/common/http';
import { DefaultUrlSerializer, UrlTree } from '@angular/router';
import { MsalGuardConfiguration, MsalInterceptorConfiguration } from '@azure/msal-angular';
import { BrowserCacheLocation, InteractionType, IPublicClientApplication, LogLevel, PublicClientApplication } from '@azure/msal-browser';
import { AppConfigService } from './config/app-config.service';
import { AuthService } from './modules/auth/_services/auth.service';


//import { GlobalErrorHandler } from './globalerrorhandler';


function appInitializer(authService: AuthService, http: HttpClient) {

  ////http.get("api/TokenService/getDSNAPToken",{  responseType: 'text' }).subscribe((res) => {
  ////     sessionStorage.setItem('token', res);
  ////});
  ////return () => {
    
  ////  return new Promise((resolve) => {
  ////    authService.getUserByToken().subscribe().add(resolve);
     
  ////  });
  ////};
}
export function loggerCallback(logLevel: LogLevel, message: string) {
  console.log(message);
}
const isIE = window.navigator.userAgent.indexOf("MSIE ") > -1 || window.navigator.userAgent.indexOf("Trident/") > -1;
export function MSALInstanceFactory(): IPublicClientApplication {
  return new PublicClientApplication({
    auth: {
      clientId: '9df39b01-a267-44bc-a645-5dc599faa597', // Prod enviroment. Uncomment to use.
      authority: 'https://iowadhsb2c.b2clogin.com/iowadhsb2c.onmicrosoft.com/B2C_1_susi', // PPE testing environment.
      redirectUri: '/client/dashboard',
      postLogoutRedirectUri: '/',
      knownAuthorities: ["iowadhsb2c.b2clogin.com"]
    },
    cache: {
      cacheLocation: BrowserCacheLocation.SessionStorage,
      storeAuthStateInCookie: isIE, // set to true for IE 11. Remove this line to use Angular Universal
    },
    system: {
      loggerOptions: {
        loggerCallback,
        logLevel: LogLevel.Info,
        piiLoggingEnabled: false
      }
    }
  });
}
export function MSALGuardConfigFactory(): MsalGuardConfiguration {
  return {
    interactionType: InteractionType.Redirect,
    authRequest: {
      scopes: ['https://iowadhsb2c.onmicrosoft.com/9df39b01-a267-44bc-a645-5dc599faa597/user.read']
    },
    loginFailedRoute: '/login-failed'
  };
}
export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
  const protectedResourceMap = new Map<string, Array<string>>();  
  protectedResourceMap.set('https://graph.microsoft-ppe.com/v1.0/me', ['https://iowadhsb2c.onmicrosoft.com/9df39b01-a267-44bc-a645-5dc599faa597/user.read']);

  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap
  };
}
export class LowerCaseUrlSerializer extends DefaultUrlSerializer {
  parse(url: string): UrlTree {
    if (url.indexOf("verifycommunication") != -1)
      return super.parse(url);
    if (url.indexOf("unsubscribe") != -1)
      return super.parse(url);

    let newurl = url.split('?')[0];
    let query = url.split('?')[1];
    if (query == null)
      return super.parse(newurl.toLowerCase() );
   
    return super.parse(newurl.toLowerCase() + (query !== '' ? `?${query}` : ''));
  }
};

const appInitializerConfig = (appConfig: AppConfigService) => {
  return () => {
    return appConfig.loadAppConfig();
  };
};


